/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type RegenerateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBodyData =
  {
    message: string;
  };

/**
 * Rate limited
 */
export class RegenerateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$:
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBodyData;

  constructor(
    err:
      RegenerateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "RegenerateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type RegenerateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBodyData =
  {
    message: string;
  };

/**
 * Conflict
 */
export class RegenerateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$:
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBodyData;

  constructor(
    err:
      RegenerateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "RegenerateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type RegenerateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBodyData =
  {
    message: string;
  };

/**
 * Not found
 */
export class RegenerateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$:
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBodyData;

  constructor(
    err:
      RegenerateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "RegenerateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type RegenerateServiceAccountApiKeyAuthServiceAccountsResponseResponseBodyData =
  {
    message: string;
  };

/**
 * Forbidden
 */
export class RegenerateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$:
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponseResponseBodyData;

  constructor(
    err:
      RegenerateServiceAccountApiKeyAuthServiceAccountsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "RegenerateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type RegenerateServiceAccountApiKeyAuthServiceAccountsResponseBodyData =
  {
    message: string;
  };

/**
 * Unauthorized
 */
export class RegenerateServiceAccountApiKeyAuthServiceAccountsResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: RegenerateServiceAccountApiKeyAuthServiceAccountsResponseBodyData;

  constructor(
    err: RegenerateServiceAccountApiKeyAuthServiceAccountsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RegenerateServiceAccountApiKeyAuthServiceAccountsResponseBody";
  }
}

/**
 * Bad request
 */
export type RegenerateServiceAccountApiKeyResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class RegenerateServiceAccountApiKeyResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: RegenerateServiceAccountApiKeyResponseBodyData;

  constructor(
    err: RegenerateServiceAccountApiKeyResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "RegenerateServiceAccountApiKeyResponseBody";
  }
}

/** @internal */
export const RegenerateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RegenerateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type RegenerateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const RegenerateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody
  > = z.instanceof(
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse429ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RegenerateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RegenerateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type RegenerateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const RegenerateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody
  > = z.instanceof(
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse409ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RegenerateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RegenerateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type RegenerateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const RegenerateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody
  > = z.instanceof(
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponse404ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RegenerateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody$inboundSchema:
  z.ZodType<
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RegenerateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type RegenerateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const RegenerateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody$outboundSchema:
  z.ZodType<
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody
  > = z.instanceof(
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponseResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RegenerateServiceAccountApiKeyAuthServiceAccountsResponseBody$inboundSchema:
  z.ZodType<
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new RegenerateServiceAccountApiKeyAuthServiceAccountsResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type RegenerateServiceAccountApiKeyAuthServiceAccountsResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const RegenerateServiceAccountApiKeyAuthServiceAccountsResponseBody$outboundSchema:
  z.ZodType<
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponseBody$Outbound,
    z.ZodTypeDef,
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponseBody
  > = z.instanceof(
    RegenerateServiceAccountApiKeyAuthServiceAccountsResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const RegenerateServiceAccountApiKeyResponseBody$inboundSchema:
  z.ZodType<RegenerateServiceAccountApiKeyResponseBody, z.ZodTypeDef, unknown> =
    z.object({
      message: z.string(),
      request$: z.instanceof(Request),
      response$: z.instanceof(Response),
      body$: z.string(),
    })
      .transform((v) => {
        return new RegenerateServiceAccountApiKeyResponseBody(v, {
          request: v.request$,
          response: v.response$,
          body: v.body$,
        });
      });

/** @internal */
export type RegenerateServiceAccountApiKeyResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const RegenerateServiceAccountApiKeyResponseBody$outboundSchema:
  z.ZodType<
    RegenerateServiceAccountApiKeyResponseBody$Outbound,
    z.ZodTypeDef,
    RegenerateServiceAccountApiKeyResponseBody
  > = z.instanceof(RegenerateServiceAccountApiKeyResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));
